// src/components/layout/Footer.jsx
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="bg-[#b7b7b7] text-black">
      <div className="container mx-auto px-4 py-10">
        {/* Top grid: 1) Ποιοι Είμαστε (CENTER) 2) Δραστηριότητες (LEFT) 3) Επικοινωνία (LEFT) */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 items-start">
          {/* Ποιοι Είμαστε */}
          <div className="md:order-1 text-center">
            <h3 className="text-lg font-semibold">Ποιοι Είμαστε</h3>
            <div className="mt-3 h-px bg-black/20 w-full" />

            <div className="mt-6 flex flex-col items-center">
              <img
                src={`${process.env.PUBLIC_URL}/theseus.png`}
                alt="THESEUS"
                className="h-14 sm:h-16 w-auto object-contain"
              />

              <p className="mt-5 text-sm leading-relaxed max-w-sm">
                Το Κέντρο Δια Βίου Μάθησης ΘΗΣΕΑΣ λειτουργεί με τον Κωδικό Άδειας 2000127
                Ε.Ο.Π.Π.Ε.Π που έχει λάβει από τον Εθνικό Οργανισμό Πιστοποίησης Προσόντων
                & Επαγγελματικού Προσανατολισμού (Ε.Ο.Π.Π.Ε.Π).
              </p>
            </div>
          </div>

          {/* Δραστηριότητες */}
          <div className="md:order-2 text-left">
            <h3 className="text-lg font-semibold">Δραστηριότητες</h3>
            <div className="mt-3 h-px bg-black/20 w-full" />

            <ul className="mt-6 space-y-4 text-sm leading-relaxed list-disc pl-5">
              <li>Οργάνωση Εκπαιδευτικών και Επιμορφωτικών Σεμιναρίων</li>
              <li>Διασύνδεση Καταρτιζόμενων με την αγορά Εργασίας</li>
              <li>Παροχή Συμβουλευτικών Υπηρεσιών σε Ανέργους</li>
              <li>Εκπαίδευση Εκπαιδευτών</li>
            </ul>
          </div>

          {/* Επικοινωνία */}
          <div className="md:order-3 text-left">
            <h3 className="text-lg font-semibold">Επικοινωνία:</h3>
            <div className="mt-3 h-px bg-black/20 w-full" />

            <div className="mt-6 space-y-3 text-sm leading-relaxed">
              <p>Υακίνθου 4,</p>
              <p>Καλαμίτσα Καβάλας,</p>
              <p>Τηλ. +2510.600205-07</p>

              <div>
                <Link
                  to="/contact"
                  className="underline decoration-black/30 hover:decoration-black"
                >
                  info@theseus.edu.gr
                </Link>
              </div>

              <Link to="/contact" className="text-black/60 mt-4 block">
  Επικοινωνήστε μαζί μας!
</Link>
            </div>
          </div>
        </div>

        {/* Bottom links + copyright */}
        <div className="mt-10 pt-6 border-t border-black/20 text-center text-sm text-black/70 space-y-3">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-6">
  <Link to="/privacy" className="underline decoration-black/30 hover:decoration-black">
    Πολιτική Προστασίας Προσωπικών Δεδομένων
  </Link>

  <span className="hidden sm:inline text-black/30">•</span>

  <Link to="/faq" className="underline decoration-black/30 hover:decoration-black">
    Ερωτήσεις
  </Link>

  <span className="hidden sm:inline text-black/30">•</span>

  <a
    href="https://theseus.elearninghub.gr/el/static/home"
    target="_blank"
    rel="noreferrer"
    className="underline decoration-black/30 hover:decoration-black"
  >
    Σύνδεση Τηλεκατάρτισης
  </a>
</div>

          <p>
            © {new Date().getFullYear()}{' '}
            <a
              href="https://theseus.edu.gr"
              target="_blank"
              rel="noreferrer"
              className="underline decoration-black/30 hover:decoration-black"
            >
              theseus.edu.gr
            </a>{' '}
            – All rights reserved – Digital design & support by{' '}
            <a
              href="https://datatech.gr"
              target="_blank"
              rel="noreferrer"
              className="underline decoration-black/30 hover:decoration-black"
            >
              datatech.gr
            </a>{' '}

          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
